import { AttemptState, GlobalState, State } from "./state";
import { Settings } from "../../lib/timer";

type Id = string;

export interface StateInitializer<S extends State> {
	getInitialState(cache?: S, config?: Settings): S;
}

export abstract class AttemptStateInitializer implements StateInitializer<AttemptState> {
	getInitialState(cache?: AttemptState): AttemptState {
		return {
			version: 2, timestamp: new Date().toISOString(),
			...(cache ?? {}),
			current: this.getInitialCurrent(cache),
			times: this.getInitialTimes(cache),
		};
	}
	abstract getInitialCurrent(cache?: AttemptState): AttemptState["current"];
	abstract getInitialTimes(cache?: AttemptState): AttemptState["times"];
}

export class PqAttemptStateInitializer extends AttemptStateInitializer {
	getInitialCurrent(cache?: AttemptState): AttemptState["current"] {
		return {
			...(cache?.current ?? {}),
			...getDOMCurrent()
		};
	}

	getInitialTimes(cache?: AttemptState): AttemptState["times"] {
		return {
			...(cache?.times ?? {}),
			...getDOMTimes()
		};
	}
}

export class FlashAttemptStateInitializer extends AttemptStateInitializer {
	getInitialCurrent(cache?: AttemptState): AttemptState["current"] {
		return {
			...getDOMCurrent(),
			...(cache?.current ?? {})
		};
	}

	getInitialTimes(cache?: AttemptState): AttemptState["times"] {
		return {
			...getDOMTimes(),
			...(cache?.times ?? {})
		};
	}
}

export class NullAttemptStateInitializer extends AttemptStateInitializer {
	getInitialCurrent(cache?: State): { id?: string; order: Record<string, number>; } {
		throw new Error("Method not implemented.");
	}

	getInitialTimes(cache?: State): Record<string, number> {
		throw new Error("Method not implemented.");
	}
}

export class GlobalStateInitializer implements StateInitializer<GlobalState> {
	getInitialState(cache?: GlobalState, config?: Settings): GlobalState {
		return {
			version: 2, timestamp: new Date().toISOString(),
			timer: {
				advanceRate: config?.advanceRate ?? 30000,
				autoAdvance: config?.autoAdvance ?? false,
				timed: config?.timed ?? false,
			},
			settings: { fontsize: 1, randomize: false, },
			...(cache ?? {})
		};
	}
}

export class NullStateInitializer<S extends State> implements StateInitializer<S> {
	getInitialState(cache?: S): S {
		throw new Error("Method not implemented.");
	}
}

function getDOMCurrent(): AttemptState["current"] | undefined {
	const list: HTMLElement[] = Array.from(
		document.querySelectorAll<HTMLElement>('.item-list .item')
	);
	return list?.length ? {
		id: list.at(0).dataset.id,
		order: list.reduce(
			(order: Record<Id, number>, item: HTMLElement, index: number) => ({
				...order,
				[item.dataset.id]: index
			}), {}
		)
	} : undefined;
}

function getDOMTimes(): AttemptState["times"] {
	return Array.from(document.querySelectorAll('.item-list .item')).reduce(
		(times, item: HTMLElement) => ({
			...times,
			[item.dataset.id]: parseInt(item.dataset.initial)
		}), {}
	);
}

